import React from 'react';
import { HiOutlinePlus } from 'react-icons/hi2';
import { Search } from 'react-bootstrap-icons';
import CheckboxMultiSelect from '../../../../../../../../components/common/CheckboxMultiSelect/CheckboxMultiSelect';
import './FilterBar.scss';

interface FilterOption {
  value: string | number;
  label: string;
}

interface FilterBarProps {
  puestosOptions: FilterOption[];
  selectedPuesto: FilterOption[];
  selectedEstado: FilterOption[];
  onPuestoChange: (selected: FilterOption[]) => void;
  onEstadoChange: (selected: FilterOption[]) => void;
  searchValue: string;
  onSearchChange: (value: string) => void;
  onCreateInvitation: () => void;
}

const FilterBar: React.FC<FilterBarProps> = ({
  puestosOptions,
  selectedPuesto,
  selectedEstado,
  onPuestoChange,
  onEstadoChange,
  searchValue,
  onSearchChange,
  onCreateInvitation,
}) => {
  const estadoOptions = [
    { value: 1, label: 'Válido' },
    { value: 0, label: 'Inválido' }
  ];

  return (
    <div className="mp-toolbar flex flex-wrap items-center gap-3">
      <div className="search-wrapper">
        <Search size={14} className="search-icon" />
        <input
          type="text"
          placeholder="Buscar invitaciones..."
          value={searchValue}
          onChange={(e) => onSearchChange(e.target.value)}
          className="search-input"
        />
      </div>

      <div className="min-w-[120px]">
        <CheckboxMultiSelect options={puestosOptions} value={selectedPuesto} onChange={onPuestoChange} placeholder="Puestos" />
      </div>
      <div className="min-w-[110px]">
        <CheckboxMultiSelect options={estadoOptions} value={selectedEstado} onChange={onEstadoChange} placeholder="Estado" />
      </div>

      <button className="mp-btn-primary" onClick={onCreateInvitation}>
        <HiOutlinePlus size={16} /> Crear invitación
      </button>
    </div>
  );
};

export default FilterBar;
